import React from "react";
import ReactECharts from "echarts-for-react";

class StackedBarChartTemplate2 extends React.Component {
  constructor(props) {
    super(props);
  }

  getRandomColor() {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  getOption = (stackData, xAxisData, seriesData, xAxisName) => {
    return {
      legend: {
        data: stackData ? stackData : [],
        orient: "horizontal",
        right: 57,
        top: 2,
      },
      tooltip: {
        trigger: "item",
      },
      xAxis: {
        data: xAxisData,
        name: xAxisName,
        nameLocation: "middle",
        nameGap: 54,
        nameTextStyle: {
          color: "#333",
          fontSize: 14,
          fontWeight: 500,
        },
        axisLabel: {
          ...(xAxisData &&
            xAxisData.length > 2 && {
              width: 70,
              overflow: "truncate",
              ellipsis: "...",
            }),
          show: true,
          interval: 0,
        },
        axisLine: { onZero: true },
        splitLine: { show: false },
        splitArea: { show: false },
      },
      yAxis: {},
      grid: {
        bottom: 100,
      },
      series: seriesData ? seriesData : [],
    };
  };

  render() {
    const { graphData, barChartConfig, graphHeight } = this.props;
    const stacked = barChartConfig.yAxis ? barChartConfig.yAxis.split(",") : [];

    let xAxisData = [];
    let seriesData = [];
    let nestedSeriesData = [];

    graphData &&
      graphData.map((g, i) => {
        let tmp = {};
        for (const key in g.tableData) {
          tmp[key.trim()] = g.tableData[key];
          if (key.trim() !== barChartConfig.xAxis) {
            const filterKey = graphData.map((el) => el.tableData[key]);
            if (stacked.length - 1 === i) {
              nestedSeriesData.push(filterKey);
            }
          }
        }
        xAxisData.push(tmp[barChartConfig.xAxis]);
      });

    stacked.map((ele, i) => {
      seriesData.push({
        name: ele,
        type: "bar",
        stack: "one",
        barWidth: 40,
        animation: true,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowColor: "rgba(0,0,0,0.3)",
          },
        },
        data: nestedSeriesData[i],
      });
    });

    return (
      <div>
        <div
          style={{ width: "100%", cursor: "pointer" }}
          className="reportMainContainer"
        >
          <ReactECharts
            option={this.getOption(
              stacked,
              xAxisData,
              seriesData,
              barChartConfig.xAxis,
            )}
            style={{ height: graphHeight, width: "108%" }}
          />
        </div>
      </div>
    );
  }
}

export default StackedBarChartTemplate2;
